import SEOHelmet from '@/components/feature/SEOHelmet';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from '@/pages/home/components/HeroSection';
import FeaturedSection from '@/pages/home/components/FeaturedSection';
import CategorySection from '@/pages/home/components/CategorySection';
import LatestSection from '@/pages/home/components/LatestSection';
import NewsletterSection from '@/pages/home/components/NewsletterSection';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '黑料不打烊',
  url: 'https://www.heiliaobudayang.com',
  description: '全天24小时不间断追踪娱乐圈最新爆料、明星黑料与劲爆内幕。独家扒皮、深度揭秘，让你第一时间掌握圈内真相。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://www.heiliaobudayang.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
  publisher: {
    '@type': 'Organization',
    name: '黑料不打烊',
    url: 'https://www.heiliaobudayang.com',
  },
};

export default function Home() {
  return (
    <>
      <SEOHelmet
        title="黑料不打烊·明星劲爆内幕全天候曝光"
        description="黑料不打烊，全天24小时不间断追踪娱乐圈最新爆料、明星黑料与劲爆内幕。独家扒皮、深度揭秘，让你第一时间掌握圈内真相，错过一秒都是损失。关注黑料不打烊，吃瓜永不缺货！"
        keywords="黑料不打烊,明星黑料爆料,娱乐圈内幕,最新吃瓜爆料,劲爆明星丑闻,24小时追星爆料,娱乐圈扒皮揭秘"
        canonicalUrl="https://www.heiliaobudayang.com"
        ogType="website"
        schema={homeSchema}
      />
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedSection />
        <CategorySection />
        <LatestSection />
        <NewsletterSection />
      </main>
      <Footer />
    </>
  );
}